export default "__VITE_ASSET__29ace9c4__"